var _circle, _circle2, _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _circle3, _path3, _g, _path4, _rect6, _rect7, _path5, _rect8, _rect9, _rect10, _rect11, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 38.25,
    r: 37.5,
    fill: "#00C1DB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 38.25,
    r: 37.5,
    fill: "#1E1A25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6703 29.3783C47.6028 26.5258 48.6703 22.8503 48.6703 20.1055C48.6703 18.1425 45.4857 18.271 44.4658 20.7361C42.5342 25.4046 44.3686 27.7504 43.5352 30.6489C43.4392 30.9827 43.3666 31.3257 43.3666 31.673V44.0421C43.3666 45.5876 42.116 46.8404 40.5705 46.8404H26.6852C24.1473 46.8404 29.3779 50.1099 30.7285 50.9292C30.932 51.0526 31.1504 51.1461 31.3784 51.2146C32.3601 51.5095 35.2258 52.4099 36.9956 53.3762C44.309 57.369 39.3566 69.5942 47.8131 70.6236C54.0917 71.3879 58.9308 68.5811 62.0596 63.5763C67.0943 55.5227 50.3058 51.9715 49.6093 42.731C49.3234 38.9391 52.8383 36.6638 51.1196 33.1987C49.8133 30.5652 49.7214 32.187 48.6703 29.3783Z",
    fill: "#F9D6BF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.68421,
    height: 13.9919,
    rx: 2.79838,
    transform: "matrix(0.696114 -0.717931 0.717933 0.696113 16 16.8184)",
    fill: "#F9D6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7685 47.0227C47.1866 42.9384 42.7217 31.1808 47.8772 32.9228C49.5808 33.4985 51.3134 36.1841 50.6831 37.5269C47.5766 44.1454 48.0942 45.0141 51.8856 49.4207C54.6916 52.6821 58.5787 53.9321 60.7043 58.2452C63.2096 63.329 49.0796 72.5372 45.2716 67.0698C42.2699 62.7602 42.9666 56.3269 38.7578 53.4493C37.8024 52.7961 37.8478 50.4332 38.3571 49.4207C39.6598 46.831 41.9564 49.1879 43.7685 47.0227Z",
    fill: "#FFD2B5",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3432,
    y: 4.09128,
    width: 28.3213,
    height: 62.1251,
    rx: 3.30751,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3432,
    y: 4.09128,
    width: 28.3213,
    height: 62.1251,
    rx: 3.30751,
    stroke: "black",
    strokeWidth: 0.686465
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9414,
    y: 6.19238,
    width: 7.30149,
    height: 1.21692,
    rx: 0.608458,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.748,
    y: 63.8115,
    width: 11.6699,
    height: 0.686466,
    rx: 0.343233,
    fill: "#E1E1E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1133,
    cy: 29.75,
    r: 12,
    fill: "#A4E4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_1614",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 20,
    width: 28,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1143 31.25C45.6143 39.25 41.4132 41.75 35.6143 41.75C29.8153 41.75 19.6146 40.75 24.1144 31.25C24.1144 20.75 28.8154 20.75 34.6144 20.75C40.4134 20.75 54.6143 23.25 50.1143 31.25Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_654_1614)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.6099,
    y: 36.9312,
    width: 6.99415,
    height: 1.74854,
    rx: 0.874269,
    fill: "#E6A26F",
    stroke: "black",
    strokeWidth: 0.538012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5571 25.1548C28.5948 25.0256 28.7778 25.0256 28.8154 25.1548L31.4226 34.1027C31.4477 34.1888 31.3831 34.2749 31.2934 34.2749H26.0791C25.9894 34.2749 25.9249 34.1888 25.95 34.1027L28.5571 25.1548Z",
    fill: "#64B9FC",
    stroke: "black",
    strokeWidth: 0.538012
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-1_654_1614",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2886 34.6447C44.2886 32.6827 43.3817 30.8011 41.7674 29.4138C40.153 28.0265 37.9635 27.2471 35.6805 27.2471C33.3974 27.2471 31.2079 28.0265 29.5935 29.4138C27.9792 30.8011 27.0723 32.6827 27.0723 34.6447L35.6805 34.6447H44.2886Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.2886 34.6447C44.2886 32.6827 43.3817 30.8011 41.7674 29.4138C40.153 28.0265 37.9635 27.2471 35.6805 27.2471C33.3974 27.2471 31.2079 28.0265 29.5935 29.4138C27.9792 30.8011 27.0723 32.6827 27.0723 34.6447L35.6805 34.6447H44.2886Z",
    fill: "#EFF5F6",
    stroke: "black",
    strokeWidth: 1.07602,
    mask: "url(#path-14-inside-1_654_1614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.07 31.2974C40.8497 30.4476 39.2871 29.5233 37.7822 29.1039C36.3157 28.6951 34.4987 28.6528 32.9892 28.7221C32.2716 28.755 32.201 29.6382 32.8923 29.8334L41.5674 32.2825C42.2512 32.4755 42.6531 31.7034 42.07 31.2974Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7253 40.2006V40.3615C40.7253 41.3272 39.9424 42.11 38.9767 42.11H38.3018C37.7089 42.11 37.2282 41.6293 37.2282 41.0364C37.2282 40.7748 37.1327 40.5222 36.9596 40.3261L36.593 39.9106C36.347 39.6317 36.0426 39.4103 35.7016 39.262L35.4201 39.1397C34.9271 38.9253 34.3952 38.8147 33.8576 38.8147H31.7274C31.4233 38.8147 31.1379 38.6678 30.9612 38.4204C30.7274 38.093 30.7274 37.6533 30.9612 37.3259C31.1379 37.0785 31.4233 36.9316 31.7274 36.9316H36.6455C37.8273 36.9316 38.951 37.4441 39.7259 38.3364L40.2575 38.9486C40.5592 39.2959 40.7253 39.7405 40.7253 40.2006Z",
    fill: "#FFBC8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7253 42.11V41.0114C40.7253 40.0284 40.3704 39.0785 39.7259 38.3364V38.3364C38.951 37.4441 37.8273 36.9316 36.6455 36.9316H31.7274C31.4233 36.9316 31.1379 37.0785 30.9612 37.3259V37.3259C30.7274 37.6533 30.7274 38.093 30.9612 38.4204V38.4204C31.1379 38.6678 31.4233 38.8147 31.7274 38.8147H33.8576C34.3952 38.8147 34.9271 38.9253 35.4201 39.1397L35.7016 39.262C36.0426 39.4103 36.347 39.6317 36.593 39.9106V39.9106C37.0023 40.3745 37.2282 40.9718 37.2282 41.5905V42.11",
    stroke: "black",
    strokeWidth: 0.538012
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3823,
    y: 34.7788,
    width: 22.462,
    height: 1.61404,
    rx: 0.807018,
    fill: "#A95540",
    stroke: "black",
    strokeWidth: 0.538012
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.6801,
    cy: 26.4398,
    r: 0.538012,
    fill: "#F6A22E",
    stroke: "black",
    strokeWidth: 0.538012
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 17.75C40 16.9544 40.3161 16.1913 40.8787 15.6287C41.4413 15.0661 42.2044 14.75 43 14.75C43.7956 14.75 44.5587 15.0661 45.1213 15.6287C45.6839 16.1913 46 16.9544 46 17.75C46 18.5456 45.6839 19.3087 45.1213 19.8713C44.5587 20.4339 43.7956 20.75 43 20.75C42.2044 20.75 41.4413 20.4339 40.8787 19.8713C40.3161 19.3087 40 18.5456 40 17.75ZM42.8288 19.034L44.556 16.8748L44.244 16.6252L42.7712 18.4656L41.728 17.5964L41.472 17.9036L42.8288 19.0344V19.034Z",
    fill: "#26BC00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68421,
    height: 10.3736,
    rx: 2.79838,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 17.2617 52.4121)",
    fill: "#F9D6BF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.37942,
    height: 4.41834,
    rx: 1.68971,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 21.7812 43.3916)",
    fill: "#FFE2CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8499 43.4012C23.4206 43.6811 22.6832 44.1331 22.5588 43.6359C22.4413 43.1665 22.5525 42.4607 23.0283 41.9928C23.4728 41.5557 23.8592 41.4073 24.5539 41.5233C25.2581 41.6408 24.5059 42.9733 23.8499 43.4012Z",
    fill: "#FFE7D7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68421,
    height: 9.75228,
    rx: 2.79838,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 17.5195 46.0098)",
    fill: "#F9D6BF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68421,
    height: 11.099,
    rx: 2.79838,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 17 39.1035)",
    fill: "#F9D6BF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.37942,
    height: 4.41834,
    rx: 1.68971,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 21 47.3379)",
    fill: "#FFE2CE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.37942,
    height: 4.41834,
    rx: 1.68971,
    transform: "matrix(0.642788 -0.766044 0.766045 0.642787 22 41.3379)",
    fill: "#FFE2CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3342 48.6639C23.905 48.9438 23.1676 49.3957 23.0432 48.8986C22.9257 48.4292 23.0368 47.7234 23.5127 47.2555C23.9572 46.8184 24.3436 46.67 25.0383 46.786C25.7425 46.9035 24.9903 48.236 24.3342 48.6639Z",
    fill: "#FFE7D7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3342 42.6639C24.905 42.9438 24.1676 43.3957 24.0432 42.8986C23.9257 42.4292 24.0368 41.7234 24.5127 41.2555C24.9572 40.8184 25.3436 40.67 26.0383 40.7859C26.7425 40.9034 25.9903 42.236 25.3342 42.6639Z",
    fill: "#FFE7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.4dd17b183926149d8b30b2c8522ee4b2.svg";
export { ForwardRef as ReactComponent };